ChangePasswordController.$inject = [
  "Authentication.ChangePasswordServices",
  "$stateParams",
  "$scope",
  "$state"
];

function ChangePasswordController(
  ChangePasswordServices,
  stateParams,
  $scope,
  state
) {
  var self = this;

  let userId = stateParams.id;

  self.company = {
    userId: userId,
    captchaId: null
  };

  self.getCaptcha = async function () {
    let parameter = {
      type: "captcha",
      id: self.company.captchaId
    };

    await ChangePasswordServices.get(parameter).$promise.then(
      response => {
        self.captchaImage = "data:image/png;base64," + response.content.captchaImage;
        self.company.captchaId = response.content.captchaId;
      },
      errResponse => {
        iziToast.show({
          message: errResponse.data.message,
          theme: "light",
          color: "red"
        });
        console.log("fail createYear");
      }
    );
  };
  self.getCaptcha();

  $scope.otpInput = {
    size: 6,
    type: "text",
    onDone: function (value) {
      self.company.token = value;
    }
  };

  self.changePassword = async function (company, form) {
    if (form.$valid) {
      let command = {
        newPassword: company.password,
        code: company.token,
        captchaId:company.captchaId,
        captchaCode:company.captchaCode
      };

      let parameter = {
        type: "Accounts",
        id: userId,
        routeParams: "reset-password"
      };

      await ChangePasswordServices.create(parameter, command).$promise.then(
        response => {
          company = {};
          form.$setUntouched();
          form.$setPristine();
          state.go("Authentication.Login");
        },
        errResponse => {
          iziToast.show({
            message: errResponse.data.message,
            theme: "light",
            color: "red"
          });
          console.log("fail createYear");
        }
      );
    }
  };
}

module.exports = ngModule => {
  ngModule.controller(
    "Authentication.ChangePasswordController",
    ChangePasswordController
  );
};